import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          await refresh();
          setStatus("paid");
          return;
        }
        if (["expired", "failed"].includes(res.data.payment_status)) { setStatus("failed"); return; }
      } catch { /* keep polling */ }
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    if (sessionId) poll(); else setStatus("failed");
  }, [sessionId, refresh]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gp-grid-bg px-4 text-center">
      <div className="absolute top-5 left-5"><Logo /></div>
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-9 shadow-xl">
        {status === "checking" && (<><div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" /><p className="mt-5 text-muted-foreground">Verifica del pagamento in corso…</p></>)}
        {status === "paid" && (<>
          <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
          <h1 className="mt-5 font-display text-2xl font-bold">Pagamento completato!</h1>
          <p className="mt-2 text-muted-foreground">Il tuo abbonamento è attivo. Grazie per esserti unito a 412Level.</p>
          <Button onClick={() => navigate("/dashboard")} className="mt-6 rounded-xl bg-brand-500 hover:bg-brand-600 text-black" data-testid="payment-success-btn">Vai alla dashboard</Button>
        </>)}
        {["failed", "timeout"].includes(status) && (<>
          <XCircle className="mx-auto h-14 w-14 text-rose-500" />
          <h1 className="mt-5 font-display text-2xl font-bold">Qualcosa è andato storto</h1>
          <p className="mt-2 text-muted-foreground">Non siamo riusciti a confermare il pagamento. Se il problema persiste, contatta il supporto.</p>
          <Button onClick={() => navigate("/pricing")} className="mt-6 rounded-xl" variant="outline">Torna ai prezzi</Button>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gp-grid-bg px-4 text-center">
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-9 shadow-xl">
        <XCircle className="mx-auto h-14 w-14 text-muted-foreground" />
        <h1 className="mt-5 font-display text-2xl font-bold">Pagamento annullato</h1>
        <p className="mt-2 text-muted-foreground">Nessun addebito è stato effettuato.</p>
        <Button onClick={() => navigate("/pricing")} className="mt-6 rounded-xl bg-brand-500 hover:bg-brand-600 text-black">Torna ai prezzi</Button>
      </div>
    </div>
  );
}
